module.exports = __webpack_public_path__ + "img/11632.23a9c825.jpg";